import { render, staticRenderFns } from "./CollapsibleHelp.vue?vue&type=template&id=10027637"
import script from "./CollapsibleHelp.vue?vue&type=script&lang=ts"
export * from "./CollapsibleHelp.vue?vue&type=script&lang=ts"
import style0 from "./CollapsibleHelp.vue?vue&type=style&index=0&id=10027637&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports